/**
 Module to handle fetch http requests modeled after dojo/request/xhr
 */

export let fhr = {
  /**
   * The text() method of the Body mixin takes a Response stream and reads it to completion.
   * It returns a promise that resolves with a USVString object (text). The response is always decoded using UTF-8.
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Body/json
   * @param {Response} response
   * @return {Promise<String>} A Promise that resolves with a USVString.
   * @throws {Error} Throws an error with http status code and status text
   */
  text: async function(response) {
    let body = await response.text();

    if (response.ok) {

      return body;
    }

    fhr.handleErrorText(response.status, response.statusText, body);
  },

  /**
   * The json() method of the Body mixin takes a Response stream and reads it to completion.
   * The error handler function will be called with http status code, status text and http body. It should return a string to be used as the error message.
   * It returns a promise that resolves with the result of parsing the body text as JSON.
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Body/json
   * @param {Response} response
   * @return {Promise<JSON>} A Promise that resolves to a JavaScript object.
   * @throws {Error} Throws an error with http status code and status text
   */
  json: async function(response) {
    let json;

    try {
      json = await response.json();
    } catch (err) {
      throw new Error(err);
    }

    if (response.ok) {

      return json;
    }

    fhr.handleErrorJson(response.status, response.statusText, json);
  },

  /**
   *
   * @param statusCode http status code
   * @param {string} statusText http status text
   * @param {string} body http body
   */
  handleErrorText(statusCode, statusText, body) {
    let errMsg = statusCode + ' ' + statusText + (body.length > 0 ? '. ' + body : '');

    throw Error(errMsg);
  },

  /**
   *
   * @param statusCode http status code
   * @param statusText http status text
   * @param {Object} body http body
   */
  handleErrorJson(statusCode, statusText, body) {
    let errMsg = statusCode + ' ' + statusText + (body.length > 0 ? '. ' + JSON.stringify(body) : '');

    throw new Error(errMsg);
  },
};